<template>
  <div class="collapse-logo">
    <div :class="{ 'logo-wrap': true, 'logo-scale': isCollapse }" @click="backToIndex">
      <img src="@/assets/logo.png" />
      <p
        v-show="!isCollapse"
        :class="{ 'name-fade-out': isCollapse }"
        :style="{ 'font-size': isEnglish }"
      >
        {{ $t("systemName") }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
    iconName() {
      return !this.isCollapse ? "el-icon-s-fold" : "el-icon-s-unfold";
    },
    lang() {
      console.log(this.$i18n.locale);
      return this.$i18n.locale;
    },
    isEnglish() {
      return this.lang == "en_US" ? "18px" : "20px";
    },
  },
  methods: {
    ...mapActions(["handleSetCollapse", "handleSetCurrentRole", "handleGetUserMenu"]),
    setCollapse() {
      this.handleSetCollapse(!this.isCollapse);
    },
    backToIndex() {
      this.handleSetCurrentRole(false);
      this.$router.push({
        path: "/index",
      });
    },
  },
  created() {
    // this.lang = this.$i18n.locale;
  },
};
</script>
<style lang="less" scoped>
.logo-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 280px;
  height: 60px;
  padding-left: 24px;
  // padding-left: 11px;
  transition: all 0.3s;
  cursor: pointer;
  p {
    // transition: all 0.3s;
    z-index: 1;
    font-size: 22px;
    margin: 0 12px;
    font-weight: 500;
    color: #333333;
    white-space: nowrap;
  }
  .name-fade-out {
    transform: translateX(-130px);
    z-index: -1;
    color: #fff;
  }
  img {
    z-index: 10;
    padding: 5px 0;
    width: 44px;
    height: 44px;
    box-sizing: content-box;
  }
}
.logo-scale {
  width: 44px;
  padding-left: 12px;
}
.collapse-logo {
  // display: flex;
  align-items: center;
  // overflow: hidden;
}
</style>
